module.exports = __webpack_public_path__ + "static/media/icon_cook.6891a5a8.svg";